import nextId from "react-id-generator";
import check from "../../images/check-icon.svg"

export const aboutItems = [
    {
        id: nextId(),
        image: check,
        title: "your body",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, enim."
    },
    {
        id: nextId(),
        image: check,
        title: "healthy life",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, enim."
    },
    {
        id: nextId(),
        image: check,
        title: "strategies",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, enim."
    },
    {
        id: nextId(),
        image: check,
        title: "training",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, enim."
    },
]